import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ToastController} from '@ionic/angular/standalone';
import {Profile} from '@models';
import {InvitationService} from './invitation.service';
import {AnalyticsService, TranslateHelperService} from '../shared';

@Injectable()
export class PrivateMessageService {
	private invitationService;
	private readonly translateService: TranslateHelperService = inject(TranslateHelperService);
	private readonly router: Router = inject(Router);
	private readonly toastCtrl: ToastController = inject(ToastController);
	private readonly analyticsService: AnalyticsService = inject(AnalyticsService);

	constructor() {
		this.invitationService = inject(InvitationService);
	}

	async sendPrivateMessage(currentProfile: Profile, selectedProfile: Profile) {
		if (currentProfile.friends.find(f => f === selectedProfile.uuid)?.length) {
			const navigationSuccess = await this.router.navigate([
				this.translateService.localize('/app/messages'),
				{
					uuid: selectedProfile.uuid,
					username: selectedProfile.username,
					imgUrl: selectedProfile.imgUrl
				}
			]);
			if (navigationSuccess) {
				this.analyticsService.trackFunnelStep('first_interaction', {
					source_page: 'search',
					target_page: 'messages',
					interaction_type: 'message'
				});
			}
			return navigationSuccess;
		} else if (currentProfile.blocked.find(f => f === selectedProfile.uuid)?.length) {
			this.showToastError(await this.translateService.instant('Vous avez bloqué cet utilisateur'));
			return;
		} else {
			return this.invitationService.sendInvite(selectedProfile);
		}
	}

	showToastError(msg: string) {
		this.showToast(msg, 'danger');
	}

	showToast(msg: string, color: string) {
		this.toastCtrl.create({
			                      message: msg,
			                      duration: 10000,
			                      color: color,
			                      cssClass: 'yourClassName'
		                      }).then(toast => toast.present());
	}
}
